import {http} from '@/utils/http'
import {IFilter} from "@/types/main";
import {cleanParams} from "@/utils/cleanParams";
import {ISavedMessage} from "@/features/saved/saved.types";

export const savedMessagesService = {
    getSavedMessages(filter: IFilter) {
        return http.get('/saved', {
            params: cleanParams(filter)
        })
    },

    updateSavedMessage(payload: ISavedMessage) {
        return http.patch('/saved/update', payload)
    }
}